import { createAction } from 'redux-act';
import type { AccountFormData } from '#app/pages/Relations/Accounts/types/accountForm';

export const setAccountModalVisible = createAction<boolean>('SET_ACCOUNT_MODAL_VISIBLE');
export const setAccountForm = createAction<AccountFormData | null>('SET_ACCOUNT_FORM');
export const setAvailableTypes = createAction<number[]>('SET_AVAILABLE_TYPES');
export const getUserAccounts = createAction('GET_USER_ACCOUNTS');
export const handleUserAccounts = createAction<{ result?: string; data?: unknown[] }>(
  'HANDLE_USER_ACCOUNTS'
);
